import React, { useMemo, useCallback, useEffect } from 'react';
import { TUXPortal } from '../TUXPortal/TUXPortal.js';
import { TUXProvider } from '../TUXProvider/TUXProvider.js';
import { useScrollLock } from '../../hooks/useScrollLock.js';

var TUXSheetWIP = function TUXSheetWIP(_ref) {
  var _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      onDismiss = _ref.onDismiss,
      header = _ref.header,
      children = _ref.children,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 240 : _ref$minHeight,
      getContainer = _ref.getContainer,
      _ref$hasOverlay = _ref.hasOverlay,
      hasOverlay = _ref$hasOverlay === void 0 ? true : _ref$hasOverlay;

  var _useScrollLock = useScrollLock({
    defaultLock: isVisible
  }),
      lock = _useScrollLock.lock,
      unlock = _useScrollLock.unlock;

  var containerStyle = useMemo(function () {
    if (size === 'medium') {
      return {
        minHeight: minHeight,
        maxHeight: '73%',
        transform: isVisible ? 'translateY(0)' : ''
      };
    } else {
      return {
        height: '95%',
        transform: isVisible ? 'translateY(0)' : ''
      };
    }
  }, [size, minHeight, isVisible]);
  var onDismissHandler = useCallback(function () {
    onDismiss && onDismiss();
  }, [onDismiss]);
  useEffect(function () {
    isVisible ? lock() : unlock();
  }, [isVisible, lock, unlock]);
  return /*#__PURE__*/React.createElement(TUXPortal, {
    getContainer: getContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: 'box-border text-color-TextPrimary'
  }, hasOverlay && /*#__PURE__*/React.createElement("div", {
    className: "tt-sheet__mask fixed background-color-SDSecondary " + (isVisible ? 'z-2000 opacity-100' : '-z-1 opacity-0'),
    role: "none",
    onClick: onDismissHandler
  }), /*#__PURE__*/React.createElement("div", {
    className: "tt-sheet__container pb-safe fixed z-2000 background-color-BGSecondary flex flex-col",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "tt-sheet__header flex-shrink-0"
  }, /*#__PURE__*/React.createElement(TUXProvider, {
    navBarHeight: 52
  }, header)), /*#__PURE__*/React.createElement("div", {
    className: "tt-sheet__body flex-auto"
  }, children))));
};

export { TUXSheetWIP };
//# sourceMappingURL=TUXSheet.js.map
